import React, { useEffect, useState } from "react";
import "./style.scss";

const Header = () => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 1);
    });
  }, []);

  return (
    <>
      <header className={scroll ? "header background-row" : "header"}>
        <div className="container">
          <div className="main-header">
            <div className="left">
              <div className="box-img">
                <img src="./images/logo.svg" alt="" />
              </div>
            </div>
            <div className="center">
              <div className="main-menu">
                <ul className="list-menu">
                  <li>
                    <a href="#tarotx">Home</a>
                  </li>
                  <li>
                    <a href="#features">Features</a>
                  </li>
                  <li>
                    <a href="#howitworks">How It Works</a>
                  </li>
                  <li>
                    <a href="#agentTarot">AI Agent Tarot</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="right">
              <div className="row-login">
                <button className="btn-started">Buy now</button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
export default Header;
